var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    stroke: "#9DA1B5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9008 2.35029L5.86983 2.05835C6.18965 1.96215 6.53356 1.98549 6.83742 2.12401C7.14128 2.26254 7.38433 2.50679 7.52124 2.81119L8.20061 4.32088C8.31852 4.58279 8.35139 4.87502 8.29459 5.15655C8.2378 5.43808 8.09419 5.69476 7.88394 5.89056L6.84987 6.85337C6.71129 6.98484 6.81635 7.49724 7.32263 8.37406C7.82941 9.25138 8.22112 9.59831 8.40172 9.54432L9.75647 9.1304C10.0311 9.04647 10.3251 9.05051 10.5973 9.14195C10.8695 9.23339 11.1062 9.40765 11.2743 9.6403L12.2398 10.9775C12.4348 11.2476 12.5251 11.5791 12.494 11.9107C12.4628 12.2422 12.3122 12.5512 12.0702 12.7802L11.3238 13.4865C11.0829 13.7145 10.7857 13.8746 10.4626 13.9504C10.1396 14.0262 9.80214 14.015 9.48482 13.9179C7.92096 13.4395 6.47266 12.0198 5.12042 9.67879C3.76518 7.33427 3.2534 5.35667 3.61009 3.741C3.68203 3.41545 3.83956 3.11495 4.06644 2.8705C4.29332 2.62604 4.58134 2.44647 4.9008 2.35029V2.35029Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.36387dc9ed343d5c67deb2a5418088f2.svg";
export { ForwardRef as ReactComponent };